function copy(inputObject){
	var arrayConstructor = [].constructor;
	var objectConstructor = {}.constructor;

	var output;
	if (inputObject === null) {
		output = null;
	}
	else if (inputObject === undefined) {
		output = undefined;
	}
	else if (inputObject.constructor === arrayConstructor) {
		output = [];
		inputObject.forEach(element =>{
			output.push(copy(element));
		})
	}
	else if (inputObject.constructor === objectConstructor) {
		output = {};
		var item;
		for (item in inputObject){
			output[item] = copy(inputObject[item]);
		}
	}
	else {
		output = inputObject;
	}
	return output;
};
function copyAs(inputObject, value){
	var arrayConstructor = [].constructor;
	var objectConstructor = {}.constructor;

	var output;
	if (inputObject === null) {
		output = null;
	}
	else if (inputObject === undefined) {
		output = undefined;
	}
	else if (inputObject.constructor === arrayConstructor) {
		output = [];
		inputObject.forEach(element =>{
			output.push(copyAs(element, value));
		})
	}
	else if (inputObject.constructor === objectConstructor) {
		output = {};
		var item;
		for (item in inputObject){
			output[item] = copyAs(inputObject[item], value);
		}
	}
	else {
		output = value;
	}
	return output;
};
function countJSONKeys(input){
	var num = 0;
	for (var key in input){
		num++;
	}
	return num;
}
function arrayToJSON(input){
	var output = {};
	var ID;

	for (var index = 0; index < input.length; index++){
		ID = input[index].ID || index.toString();
		output[ID] = copy(input[index]);
		delete output[ID].ID;
	}

	return output;
}
function jsonToArray(input){
	var output = [];
	var elemNow;

	for (var key in input){
		elemNow = copy(input[key]);
		elemNow.ID = key;
		output.push(elemNow);
	}
	return output;
}
export default {
	copy,
	copyAs,
	countJSONKeys,
	arrayToJSON,
	jsonToArray
}



// WEBPACK FOOTER //
// ./src/assets/js/copyManager.js